import { z } from 'zod';
import { IncidentTableColumns } from '@/routes/_stacktrace/incidents/-table/type';
import { IncidentCategory, IncidentPriority, IncidentSeverity, IncidentStatusTab } from './-query/type';
const incidentStatusTabValues = Object.values(IncidentStatusTab) as [IncidentStatusTab, ...IncidentStatusTab[]];
export const IncidentStatusTabSchema = z.enum(incidentStatusTabValues);

/**
 * インシデント一覧のステータスタブ並び順。
 *   open → resolved → closed → canceled → all
 */
export const STATUS_TABS = [IncidentStatusTab.OPEN, IncidentStatusTab.RESOLVED, IncidentStatusTab.CLOSED, IncidentStatusTab.CANCELED, IncidentStatusTab.ALL] as const satisfies readonly IncidentStatusTab[];

/** 重大度フィルタチップの表示順（SEV1 → SEV4）。 */
export const SEVERITY_ORDER: IncidentSeverity[] = [IncidentSeverity.SEV1, IncidentSeverity.SEV2, IncidentSeverity.SEV3, IncidentSeverity.SEV4];

/** 分類フィルタチップの表示順。 */
export const CATEGORY_ORDER: IncidentCategory[] = [IncidentCategory.FAILURE, IncidentCategory.DEGRADATION, IncidentCategory.SECURITY, IncidentCategory.DATA, IncidentCategory.EXTERNAL];

/** 優先度フィルタチップの表示順（P1 → P5）。 */
export const PRIORITY_ORDER: IncidentPriority[] = [IncidentPriority.P1, IncidentPriority.P2, IncidentPriority.P3, IncidentPriority.P4, IncidentPriority.P5];
export function buildIncidentTabChangeSearch(tab: string) {
  const result = IncidentStatusTabSchema.safeParse(tab);
  return {
    status: result.success ? result.data : IncidentStatusTab.OPEN,
    pageIndex: 0,
    sortColumn: IncidentTableColumns.CODE,
    orderDirection: 'asc' as const
  };
}